<template>
  <loading v-if="loading" />
  <error-messages
    v-else-if="!loading && errorMessagesGetList.length > 0"
    :messages="errorMessagesGetList"
  />
  <empty-list
    v-else-if="
      !loading && errorMessagesGetList.length === 0 && items.length === 0
    "
    :srcImage="require('@/assets/images/backup-empty.png')"
    btnText="ایجاد فایل پشتیبان"
    @btnCreateClicked="showCreateModal"
  >
    <template v-slot:messages>
      <p>
        <strong>
          پشتیبان‌گیری به صورت دستی را می‌توانید انجام دهید.
        </strong>
      </p>
      <p>
        همچنین لیست کلیه‌ی پشتیبان‌های مربوط به این برنامه (خودکار و دستی) در
        دسترس است.
      </p>
    </template>
    <create-backup-modal
      :visible="visibleCreateModal"
      @hidden="hiddenCreateModal"
      @createSuccess="getListBackup"
    />
  </empty-list>
  <main-page-service
    v-else
    title="لیست فایل‌های پشتیبان دستی"
    btnText="ایجاد فایل پشتیبان"
    @btnCreateClicked="showCreateModal"
  >
    <b-table
      responsive
      hover
      :items="items"
      :fields="fields"
      table-class="table-list-table"
      thead-tr-class="table-list-thead-tr"
      tbody-tr-class="table-list-tbody-tr"
    >
      <template #cell(isAutomatic)="data">
        <span v-if="data.item.isAutomatic">خودکار</span>
        <span v-else>دستی</span>
      </template>
      <template #cell(operation)="data">
        <b-button pill variant="light" :href="data.item.url" target="_blank">
          <b-icon icon="download"></b-icon>
        </b-button>
      </template>
    </b-table>
    <create-backup-modal
      :visible="visibleCreateModal"
      @hidden="hiddenCreateModal"
      @createSuccess="getListBackup"
    />
  </main-page-service>
</template>

<script>
import MainPageService from "@/components/MainPageService/MainPageService.vue";
import Loading from "@/components/Loading/Loading.vue";
import EmptyList from "@/components/EmptyList/EmptyList.vue";
import { backupUserList } from "@/services/service";
import CreateBackupModal from "./CreateBackupModal";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";

export default {
  name: "AppFileManager",
  components: {
    EmptyList,
    Loading,
    MainPageService,
    CreateBackupModal,
    ErrorMessages
  },
  data() {
    return {
      loading: false,
      errorMessagesGetList: [],
      items: [],
      fields: [
        {
          key: "createdAt",
          label: "تاریخ و ساعت ایجاد",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "isAutomatic",
          label: "نوع پشتبان‌گیری",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "operation",
          label: "لینک دانلود",
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],
      // create modal data
      visibleCreateModal: false
    };
  },
  mounted() {
    this.getListBackup();
  },
  methods: {
    getListBackup: async function() {
      this.loading = true;
      const [error, data] = await backupUserList(this.$route.params.serviceId);
      if (error) {
        this.errorMessagesGetList = error;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          this.items = [...data.apiData];
          this.loading = false;
        } else {
          this.errorMessagesGetList = data.apiErrors;
          this.loading = false;
        }
      }
    },
    // create modal method
    showCreateModal: function() {
      this.visibleCreateModal = true;
    },
    hiddenCreateModal: function() {
      this.visibleCreateModal = false;
    }
  }
};
</script>

<style></style>
